import { slideDown, slideUp } from "slide-anim";

export const collapse = function (el) {
    const className = el.getAttribute("data-class");

    if (el.parentNode.classList.contains(className)) {
        el.parentNode.classList.remove(className);
        slideUp(el.nextElementSibling);
    } else {
        el.parentNode.classList.add(className);
        slideDown(el.nextElementSibling);
    }
};
